import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { observer } from 'mobx-react-lite';
import { useStore } from '@shared/hooks/useStore';
import { ROUTES, SCREEN_TYPE } from '@shared/configs/constants';
import { ThreeCircles } from 'react-loader-spinner';

const LoginSSOPage = observer(() => {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const { authStore } = useStore();

    const ssoToken = searchParams.get('ssoToken');
    const orgId = searchParams.get('orgId');
    const service = searchParams.get('service');

    useEffect(() => {
        const loginSSO = async () => {
            if (!ssoToken || !orgId || !service) {
                navigate(ROUTES.home.href, { replace: true });
                return;
            }

            const success = await (authStore.loginSSO({ ssoToken, orgId, service, screenType: SCREEN_TYPE.GA }) as any);
            if (success) {
                navigate(ROUTES.home.href, { replace: true });
            } else {
                navigate(ROUTES.home.href, { replace: true });
            }
        };

        loginSSO();
    }, []);

    return (
        <div className='flex items-center justify-center w-full h-screen'>
            <ThreeCircles
                width={60}
                height={60}
                color=''
            />
        </div>
    );
});

export default LoginSSOPage;
